import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        await checkAuth();
        // If a booking was in progress, return user to home so it can resume.
        let dest = "/dashboard";
        try {
          if (sessionStorage.getItem("pending_booking")) {
            dest = "/";
          }
        } catch {}
        if (dest === "/dashboard") {
          if (data?.role === "admin") dest = "/admin";
          else if (data?.role === "driver") dest = "/driver";
        }
        navigate(dest, { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0D0D0D] text-white">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#121212] border-t-transparent rounded-full animate-spin mx-auto mb-5" />
        <p className="text-[#888888] tracking-wide">Inloggen…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
